import { render, staticRenderFns } from "./card-pax.vue?vue&type=template&id=b6e97140&scoped=true&"
import script from "./card-pax.vue?vue&type=script&lang=js&"
export * from "./card-pax.vue?vue&type=script&lang=js&"
import style0 from "./card-pax.vue?vue&type=style&index=0&id=b6e97140&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e97140",
  null
  
)

export default component.exports